import React, { useEffect, useState, useContext } from "react";
import api, { API_URL, showAlert, AuthContext } from "../util/api";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../header";
import Footer from "../footer";

const ConsultationReadOnly = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  // Accept states
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // Reject states
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectComment, setRejectComment] = useState("");
  const [rejecting, setRejecting] = useState(false);

  const router = useNavigate();
  const { User } = useContext(AuthContext);
  const { id } = useParams();

  /* -----------------------------
     Fetch Consultation
  ------------------------------*/
  useEffect(() => {
    const fetchConsultation = async () => {
      try {
        const res = await api.get(`${API_URL}/consultations/${id}`);

        if (res.data.status !== "success") {
          showAlert("error", "Error", res.data.message);
          return;
        }

        setData(res.data);
      } catch (error) {
        showAlert("error", "Error", "Failed to load consultation");
      } finally {
        setLoading(false);
      }
    };

    if (!User) {
      router("/login");
    } else {
      fetchConsultation();
    }
  }, [id]);

  /* -----------------------------
     Accept Consultation
  ------------------------------*/
  const submitAcceptance = async () => {
    if (rating === 0) {
      showAlert("warning", "Rating Required", "Please rate the consultation");
      return;
    }

    setSubmitting(true);

    try {
      const res = await api.post(
        `${API_URL}/consultations/${id}/accept`,
        { rating, comment }
      );

      if (res.data.status !== "success") {
        showAlert("error", "Error", res.data.message);
        return;
      }

      showAlert("success", "Success", "Consultation accepted successfully");
      setShowAcceptModal(false);
      //window.location.reload();

      router(`/appointment/${data.data.appointment_id}`);
    } catch (error) {
      showAlert("error", "Error", "Failed to submit acceptance");
    } finally {
      setSubmitting(false);
    }
  };

  /* -----------------------------
     Reject Consultation
  ------------------------------*/
  const submitRejection = async () => {
    if (rejectComment.trim() === "") {
      showAlert(
        "warning",
        "Comment Required",
        "Please explain why you are rejecting the consultation"
      );
      return;
    }

    setRejecting(true);

    try {
      const res = await api.post(
        `${API_URL}/consultations/${id}/reject`,
        { comment: rejectComment }
      );

      if (res.data.status !== "success") {
        showAlert("error", "Error", res.data.message);
        return;
      }

      showAlert("success", "Rejected", "Consultation rejected successfully");
      setShowRejectModal(false);
       router(`/appointment/${data.data.appointment_id}`);
      //window.location.reload();
    } catch (error) {
      showAlert("error", "Error", "Failed to submit rejection");
    } finally {
      setRejecting(false);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar menuColor="red" />
        <div className="text-center my-5">
          <div className="spinner-border text-primary" />
          <br />
          <span>Loading...</span>
        </div>
        <Footer />
      </>
    );
  }

  if (!data) return null;

  return (
    <>
      <Navbar menuColor="red" />

      <section style={{ marginTop: "3.5cm" }}>
        <div className="container my-5">

          <button
            onClick={() => router(`/appointment/${data.data.appointment_id}`)}
            style={{
              background: "transparent",
              border: "none",
              color: "#007bff",
              cursor: "pointer",
              fontSize: 16,
              padding: 0,
            }}
          >
            ← Back
          </button>

          <div className="card shadow border-0 mt-3">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0"> Consultation Summary</h4>
              <small>
                Completed on {new Date(data.completed_at).toLocaleString()}
              </small>
            </div>

            <div className="card-body">
              <small>Completed by:  {data.doctor_name}</small>
              <br />
              <small>
                <strong>Client Name:</strong> {data.data.patient.name}
              </small>

              <hr />

              <h5>Case Summary</h5>
              <p><strong>Primary:</strong> {data.casesummary.primary}</p>
              {data.casesummary.secondary && (
                <p><strong>Secondary:</strong> {data.casesummary.secondary}</p>
              )}

              <hr />

              <h5>Consultation Notes</h5>
              <div className="bg-light p-3 rounded">
                {data.consultationNotes}
              </div>

              <hr />

              <h5>Recommendations</h5>
              {data.recommendations.length === 0 && (
                <p className="text-muted">No recommendations made.</p>
              )}

              {data.recommendations.map((r, i) => (
                <div key={i} className="card mb-3">
                  <div className="card-body row">
                    <div className="col-md-4"><strong>Action:</strong> {r.action}</div>
                    <div className="col-md-2"><strong>Priority:</strong> {r.priority}</div>
                    <div className="col-md-3"><strong>Timeline:</strong> {r.timeline}</div>
                    <div className="col-md-3"><strong>Duration:</strong> {r.duration}</div>
                    {r.instructions && (
                      <div className="col-12 mt-2">
                        <strong>Instructions:</strong> {r.instructions}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <hr />

              <h5>Outcome</h5>
              <span className="badge bg-info fs-6">
                {data.outcome.replace("_", " ")}
              </span>
            </div>

            <div className="card-footer text-end">
              {User.id === data.data.patient_id && (


                <>
                {  data.data.status  !==  "COMPLETED" &&

                <>

                
                  <button
                    className="btn btn-success me-2 mb-2"
                    onClick={() => setShowAcceptModal(true)}
                  >
                    Accept {/* Consultation */}
                  </button>

                  <button
                    className="btn btn-danger me-2 mb-2"
                    onClick={() => setShowRejectModal(true)}
                  >
                    Reject {/* Consultation */}
                  </button>

                  </>

                }



                 
                   
                </>
              )}

              <button
                className="btn btn-outline-secondary me-2 mb-2"
                onClick={() => window.print()}
              >
                Print
              </button>

              <button
                className="btn btn-primary mb-2"
                onClick={() => window.history.back()}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ACCEPT MODAL */}
      {showAcceptModal && (
        <div className="modal fade show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Accept Consultation</h5>
                <button className="btn-close" onClick={() => setShowAcceptModal(false)} />
              </div>
              <div className="modal-body">
                <label>Rate Consultation</label>
                <div className="mb-3">
                  {[1,2,3,4,5].map(star => (
                    <span
                      key={star}
                      style={{
                        fontSize: 24,
                        cursor: "pointer",
                        color: star <= rating ? "#ffc107" : "#ccc"
                      }}
                      onClick={() => setRating(star)}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Optional comment"
                  value={comment}
                  onChange={e => setComment(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowAcceptModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-success" onClick={submitAcceptance} disabled={submitting}>
                  {submitting ? "Submitting..." : "Submit Acceptance"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* REJECT MODAL */}
      {showRejectModal && (
        <div className="modal fade show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-danger text-white">
                <h5>Reject Consultation</h5>
                <button className="btn-close btn-close-white" onClick={() => setShowRejectModal(false)} />
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Explain why you are rejecting this consultation"
                  value={rejectComment}
                  onChange={e => setRejectComment(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRejectModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={submitRejection} disabled={rejecting}>
                  {rejecting ? "Submitting..." : "Confirm Rejection"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default ConsultationReadOnly;
